<template>
    <!-- Rendering in a separate html file fails -->
    <base-dialog
        :model-value="modelValue"
        :label="label"
        @update:model-value="(v) => $emit('update:modelValue', v)">
        <v-btn
            block
            :loading="isExporting"
            :disabled="isImporting"
            prepend-icon="mdi-export"
            size="large"
            color="primary"
            @click="exportEmails">
            Export
        </v-btn>
        <v-file-input
            v-model="importFile"
            :clearable="false"
            :loading="isImporting"
            :disabled="isExporting"
            class="mt-4"
            label="Import"
            accept=".xlsx"
            variant="outlined"
            prepend-icon=""
            prepend-inner-icon="mdi-import"
            @update:model-value="importEmails"></v-file-input>
    </base-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseDialog from "@/components/BaseDialog/BaseDialog.vue";
import downloadUtils from "@/services/downloadUtils";
import marketApi from "@/api/marketApi";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";
import { AxiosError } from "axios";

export default defineComponent({
    components: {
        BaseDialog
    },
    props: {
        label: { type: String, required: true },
        modelValue: { type: Boolean, required: true }
    },
    emits: ["update:modelValue"],
    data() {
        return {
            isExporting: false,
            isImporting: false,
            importFile: null as File | null
        };
    },
    methods: {
        ...notificationsModule.mapActions({
            notifyError: NotificationsActions.NotifyError,
            notifySuccess: NotificationsActions.NotifySuccess
        }),
        async exportEmails(): Promise<void> {
            this.isExporting = true;
            try {
                const exportResponse = await marketApi.exportEmails();
                console.log(exportResponse);
                downloadUtils.download(
                    exportResponse.data,
                    "market-emails-export.xlsx"
                );
            } finally {
                this.isExporting = false;
            }
        },
        async importEmails(files: File | File[]): Promise<void> {
            const file = Array.isArray(files) ? files.at(0) : files;
            if (!file) return;

            this.isImporting = true;
            try {
                await marketApi.importEmails(file);
            } catch (error) {
                const axiosError = error as AxiosError;
                if (!axiosError.isAxiosError) throw error;

                console.log(axiosError);
                this.notifyError(axiosError.response?.data);
                return;
            } finally {
                this.isImporting = false;
                this.importFile = null;
            }

            this.notifySuccess("Market emails have been successfuly updated.");
        }
    }
});
</script>
